<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title>
      {{listings.title}}
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-list>
    <ion-item *ngFor="let listItem of listings.listItems" (click)="selectListing(listItem)" detail>
      <ion-label>{{listItem.label}}</ion-label>
      <ion-icon slot="start" [name]="listItem.ionIcon"></ion-icon>
    </ion-item>
  </ion-list>

  <ion-fab vertical="bottom" horizontal="center" slot="fixed">
    <ion-fab-button color="dark" (click)="back()">
      <ion-icon name="close"></ion-icon>
    </ion-fab-button>
  </ion-fab>
</ion-content>